<template>
  <auth-template>
    <template v-slot:main>

      <div class="form" v-if="step == 1">
        <div class="head">
          <h3 class="title">Забыли пароль?</h3>
          <p class="sub_title_text">Введите адрес электронной почты. В течение нескольких минут мы вышлем на него инструкции по восстановлению пароля</p>
        </div>

        <div class="body">

          <form>
          <standart-filed
              id="email" title="Электронная почта" type="text" placeholder="Введите почту"
              :value="form_s1.email" @updated="form_s1.email = $event"
              :error-text="errors_s1.email"
          >
          </standart-filed>
          </form>

          <div class="share_error_b" v-show="error != ''">
            <p v-html="error"></p>
          </div>

          <div class="bottom">
            <standart-button @click="sendCode()" style_type="prime" text="Восстановить доступ"></standart-button>
            <p>Вспомнили пароль? <span
                @click="$router.push({name:'login'})" class="bl">Войти в аккаунт</span>
            </p>
          </div>

        </div>
      </div>



      <div class="form" v-if="step == 2">
        <div class="head">
          <h3 class="title">Восстановление пароля</h3>
          <p class="sub_title_text">Введите код подтверждения</p>
        </div>

        <div class="body">

          <form>
          <standart-filed
              id="code" title="Код подтверждения" type="text" placeholder="Код подтверждения"
              :value="form_s2.code" @updated="form_s2.code = $event"
              :error-text="errors_s2.code"
          >
          </standart-filed>
          </form>

          <div class="share_error_b" v-show="error != ''">
            <p v-html="error"></p>
          </div>

          <div class="bottom">
            <standart-button @click="confCode()" style_type="prime" text="Подтвердить"></standart-button>
            <p>Вспомнили пароль? <span
                @click="$router.push({name:'login'})" class="bl">Войти в аккаунт</span>
            </p>
          </div>

        </div>
      </div>



      <div class="form" v-if="step == 3">
        <div class="head">
          <h3 class="title">Восстановление пароля</h3>
          <p class="sub_title_text">Придумайте новый пароль</p>
        </div>

        <div class="body">

          <form>
          <standart-filed
              id="password" title="Пароль" type="password" placeholder="Введите пароль"
              :value="form_s3.password" @updated="form_s3.password = $event"
              :error-text="errors_s3.password"
          >
          </standart-filed>

          <standart-filed
              id="conf_password" title="Пароль проверка" type="password" placeholder="Повторите пароль"
              :value="form_s3.conf_password" @updated="form_s3.conf_password = $event"
              :error-text="errors_s3.conf_password"
          >
          </standart-filed>
          </form>

          <div class="share_error_b" v-show="error != ''">
            <p v-html="error"></p>
          </div>

          <div class="bottom">
            <standart-button @click="changePassword()" style_type="prime" text="Изменить пароль"></standart-button>
            <p>Вспомнили пароль? <span
                @click="$router.push({name:'login'})" class="bl">Войти в аккаунт</span>
            </p>
          </div>

        </div>
      </div>

      <div class="form success" v-if="step == 4">
        <div class="head">
          <h3 class="title">Вы успешно изменили пароль!</h3>
          <p class="sub_title_text"></p>
        </div>

        <div class="body">

          <div class="bottom">
            <standart-button @click="$router.push({name:'login'})" style_type="prime" text="Войти в личный кабинет"></standart-button>
          </div>

        </div>
      </div>



    </template>
  </auth-template>
</template>

<script>
// @ is an alias to /src
import AuthTemplate from '@/components/AuthTemplate.vue';
import StandartFiled from "@/components/share/StandartField";
import StandartButton from "@/components/share/StandartButton";
import axios from "axios";

export default {
  name: 'ForgotView',
  components: {
    StandartButton,
    StandartFiled,
    AuthTemplate,
  },
  data() {
    return{
      form_s1 : {
        email : "",
      },
      form_s2 : {
        code : "",
      },
      form_s3 : {
        password : "",
        conf_password : "",
      },
      errors_s1: {
        email : "",
      },
      errors_s2: {
        code : "",
      },
      errors_s3: {
        password : "",
        conf_password : "",
      },
      error: "",
      step: 1
    }
  },
  methods : {
    sendCode: async function() {
      if(!this.validate_s1()) {return;}

      try {
        const bodyFormData = new FormData;

        for(let field in this.form_s1) {
          bodyFormData.append(field, this.form_s1[field]);
        }

        let res = await axios.post(window.api_url + 'auth/send_code', bodyFormData);

        if (res.data.status === "fail") {
          this.error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          this.step = 2;
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    },
    confCode: async function() {
      if(!this.validate_s2()) {return;}

      try {
        const bodyFormData = new FormData;

        bodyFormData.append("email", this.form_s1.email);
        bodyFormData.append("code", this.form_s2.code);

        let res = await axios.post(window.api_url + 'auth/confirm_code', bodyFormData);

        if (res.data.status === "fail") {
          this.error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          this.step = 3;
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    },
    changePassword: async function() {
      if(!this.validate_s3()) {return;}

      try {
        const bodyFormData = new FormData;

        for(let field in this.form_s3) {
          bodyFormData.append(field, this.form_s3[field]);
        }

        let res = await axios.post(window.api_url + 'auth/change_password', bodyFormData);

        if (res.data.status === "fail") {
          this.error = res.data.message;
          return;
        }

        if (res.data.status  === 'success') {
          console.log("success");
          this.step = 4;
        }
      } catch (e) {
        console.log(e);
      } finally {
        console.log("end");
      }
    },
    validate_s1: function() {
      for(let field in this.form_s1) {this.errors_s1[field] = "";}
      this.error = "";

      let validation = true;

      const EMAIL_REGEXP = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;

      for(let field in this.form_s1) {
        if(this.form_s1[field] == "") {
          this.errors_s1[field] = "Обязательное поле";
          validation = false;
        }

        if(field == "email"){
          if(!EMAIL_REGEXP.test(this.form_s1[field]) && this.form_s1[field] != "") {
            this.errors_s1[field] = "Электронная почта введена некорректно";
            validation = false;
          }
        }
      }

      return validation;
    },
    validate_s2: function() {
      for(let field in this.form_s2) {this.errors_s2[field] = "";}
      this.error = "";

      let validation = true;

      for(let field in this.form_s2) {
        if(this.form_s2[field] == "") {
          this.errors_s2[field] = "Обязательное поле";
          validation = false;
        }
      }

      return validation;
    },
    validate_s3: function() {
      for(let field in this.form_s3) {this.errors_s3[field] = "";}
      this.error = "";

      let validation = true;

      for(let field in this.form_s3) {
        if(this.form_s3[field] == "") {
          this.errors_s3[field] = "Обязательное поле";
          validation = false;
        }
      }

      if(this.form_s3.password != this.form_s3.conf_password
          && this.form_s3.password != ""
          && this.form_s3.conf_password != "") {
        this.errors_s3.password = "Пароли не совпадают";
        this.errors_s3.conf_password = "Пароли не совпадают";
        validation = false;
      }

      return validation;
    }
  }
}
</script>


<style scoped>

.standart_field.password {
  margin-bottom: 18px;
}

.standart_field {
  margin-bottom: 24px;
}

.share_error_b p {
  color: var(--Red, #FA4B61);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 136%;
}

p.sub_title_text {
  width: 410px;
}

.bottom {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.bottom p {
  color: var(--Gray, #656565);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  padding: 0px;
  margin: 0px;
  text-align: center;
}

.bl {
  color: var(--Blue, #1B78BC);
  text-align: right;
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  cursor: pointer;
}


/*MOBILE*/
@media (max-width: 1250px)
{
  .standart_field.email {
    margin-bottom: 20px;
  }

  p.sub_title_text {
    width: 100%;
  }

  .bottom {
    gap: 12px;
  }
}
</style>
